// @flow
import { Map, OrderedSet } from 'immutable'
import orgInactiveNotificationsEntity from './entity'
import {
  ORG_INACTIVE_NOTIFICATIONS_CHANGE_REPEAT_DAY,
  ORG_INACTIVE_NOTIFICATIONS_SET_BEFORE_CREATE_ID,
  ORG_INACTIVE_NOTIFICATIONS_SET_ID_TO_DELETE,
} from './actionTypes'
import { OrgInactiveNotification } from '../../records/orgInactiveNotification'
import listMove from 'helpers/immutable/listMove'

const types = orgInactiveNotificationsEntity.getActionTypes()

orgInactiveNotificationsEntity.addActionReducers([
  {
    type: ORG_INACTIVE_NOTIFICATIONS_CHANGE_REPEAT_DAY,
    reducer: (state, action) => state.set('inactiveNotificationsPeriod', action.payload.day),
  },
  {
    type: ORG_INACTIVE_NOTIFICATIONS_SET_BEFORE_CREATE_ID,
    reducer: (state, action) => state.set('beforeCreateId', action.payload.id),
  },
  {
    type: types.ORG_INACTIVE_NOTIFICATIONS.GET_ALL.SUCCESS,
    reducer: (state, action) => {
      const { data } = action.payload.data
      let ids = OrderedSet()
      return state
        .set(
          'all',
          data.reduce((acc, el) => {
            ids = ids.add(el.id)
            return acc.set(el.id.toString(), new OrgInactiveNotification(el))
          }, Map())
        )
        .set('ids', ids)
        .set('inactiveNotificationsPeriod', action.payload.data.inactiveNotificationsPeriod)
        .setIn(['loaded', 'getAll'], true)
        .setIn(['pending', 'getAll'], false)
    },
  },
  {
    type: ORG_INACTIVE_NOTIFICATIONS_SET_ID_TO_DELETE,
    reducer: (state, { payload }) => {
      return state.set('idToDelete', payload.id)
    },
  },
  {
    type: types.ORG_INACTIVE_NOTIFICATIONS.DELETE.SUCCESS,
    reducer: (state, { payload }) => {
      const ids = state.get('ids').delete(payload.data)
      let index = 0
      const updatedList = state
        .get('all')
        .filter(notification => notification.id !== payload.data)
        .map(notification => notification.set('order', ++index))
      return state.set('all', updatedList).set('ids', ids).setIn(['pending', 'delete'], false)
    },
  },
  {
    type: types.ORG_INACTIVE_NOTIFICATIONS.POST.SUCCESS,
    reducer: state => {
      return state.setIn(['pending', 'post'], false)
    },
  },
  {
    type: types.ORG_INACTIVE_NOTIFICATIONS.PATCH.SUCCESS,
    reducer: state => {
      return state.setIn(['pending', 'patch'], false)
    },
  },
  {
    type: types.ORG_INACTIVE_NOTIFICATIONS_SET_ORDER,
    reducer: (state, { payload }) => {
      const { list, oldIndex, newIndex } = payload
      const newList = listMove(list, oldIndex, newIndex).map((notification, index) =>
        notification.set('order', index + 1)
      )
      return state.set(
        'all',
        newList.reduce((acc, el) => acc.set(el.get('id').toString(), el), Map())
      )
    },
  },
  {
    type: types.ORG_INACTIVE_NOTIFICATIONS.POST_REPEAT_DAY.SUCCESS,
    reducer: state => {
      return state.setIn(['pending', 'postRepeatDay'], false)
    },
  },
  {
    type: types.ORG_INACTIVE_NOTIFICATIONS.POST_ORDER.SUCCESS,
    reducer: state => {
      return state.setIn(['pending', 'postOrder'], false)
    },
  },
])

export default orgInactiveNotificationsEntity.getReducer()
